const profileValidationHR = {
    "email": {
        "required": "Email adresa je obavezna"
    },
    "profile_image": {
        "dimensions": "Veličina profilne slike mora biti točno 300 x 300 px, JPG/JPEG. Maksimalna veličina datoteke 300 KB",
        "choose": "Molimo odaberite sliku",
        "file": "Odabrana datoteka je veća od 300 KB. Molimo prenesite naslovnicu u 300x300 px, JPG/JPEG, maksimalna veličina datoteke 300 KB."
    },
    "street_and_number": {
        "required": "Ulica i kućni broj su obavezni"
    },
    "postal_code": {
        "required": "Poštanski broj je obavezan"
    },
    "city": {
        "required": "Grad je obavezan"
    },
    "country": {
        "required": "Država je obavezna"
    },
    "vat_number": {
        "invalid": "Vrijednost nije valjani PDV broj"
    },
    "iban": {
        "required": "IBAN je obavezan",
        "invalid": "Vrijednost nije valjani IBAN broj"
    },
    "cardholder_name": {
        "required": "Ime vlasnika kartice je obavezno"
    },
    "card_number": {
        "required": "Broj kartice je obavezan",
        "invalid": "Broj kartice nije valjan"
    },
    "card_year": {
        "required": "Godina isteka je obavezna",
        "invalid": "Godina isteka nije valjana"
    },
    "card_month": {
        "required": "Mjesec isteka je obavezan"
    },
    "cvc_code": {
        "required": "Sigurnosni kod (CVC) je obavezan",
        "invalid": "Sigurnosni kod (CVC) nije valjan"
    },
    "paypal_email": {
        "required": "Paypal email je obavezan",
        "invalid": "Paypal email nije valjan"
    },
    "account_holder_name": {
        "required": "Ime vlasnika bankovnog računa je obavezno"
    },
    "bank_name": {
        "required": "Naziv banke je obavezan"
    },
    "bank_address": {
        "required": "Adresa banke je obavezna"
    },
    "preferred_payment_method": {
        "required": "Preferirani način plaćanja je obavezan"
    }
};

export default profileValidationHR;